import {AddSchema, GetDoc, GetDocs, CreateAccessor, MGLClass} from "mobx-graphlink";

// proto data (ie. data returned by llm + attached-info needed for the processing immediately after [ie. before an entry is pushed to db])
export class StoryMessageProto {
	constructor(data: RequiredBy<Partial<StoryMessageProto>, "role" | "content" | "model">) { Object.assign(this, data); }

	// core data (ie. data that llm produces/expects)
	role!: "user" | "assistant";
	content!: string;
	model!: string|null;

	partial?: boolean;
	isSummary?: boolean;
	uploadedId?: string; // id of StoryMessage based on this StoryMessageProto, which has been uploaded to db
	// stored in-memory only (not persisted to db)
	thinkingContent?: string;
	outputTokens?: number;
}

@MGLClass({table: "storyMessages"})
export class StoryMessage {
	constructor(data: RequiredBy<Partial<StoryMessage>, "role" | "content" | "model" | "story">) { Object.assign(this, data); }

	// proto data (see StoryMessageProto class)
	role!: "user" | "assistant";
	content!: string;
	model!: string|null;

	id: string;
	creator: string;
	createdAt: number;

	story: string;
	parent?: string|n;

	summary_chainEnd?: string|n;
	summary_enabled?: boolean|n;
}
AddSchema("StoryMessage", {
	properties: {
		role: {type: "string"},
		content: {type: "string"},
		model: {type: ["null", "string"]},

		id: {type: "string"},
		creator: {type: "string"},
		createdAt: {type: "number"},

		story: {type: "string"},
		parent: {type: ["null", "string"]},

		summary_chainEnd: {type: ["null", "string"]},
		summary_enabled: {type: ["null", "boolean"]},
	},
	//required: [...],
});